export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/provider-retail.e8cee3bc-e48fae.svg";